import DescriptionAccordion from '../../util/DescriptionAccordion';
import SlideRequirements from './SlideRequirements';
import AudioRequirements from './AudioRequirements';

function CustomPromptsDescription() {
  return (
    <DescriptionAccordion title="Using custom prompts">
      <SlideRequirements />
      <AudioRequirements />
    </DescriptionAccordion>
  );
}

export default CustomPromptsDescription;
